@if (shouldLoad()) {
  <div>
    <cap-ech0134-grundbuchmeldung-table
      [listLoader]="listLoader"
      [showTagebuch]="false"
      [tableSortModel]="tableSortModel"></cap-ech0134-grundbuchmeldung-table>
  </div>
} @else {
  <h1>Error</h1>
}
